/* eslint-disable no-use-before-define */
import { ajax,  } from '../../twd'

var lastAjaxAbort
export const getIssueData = async (cusip) => {
    try {
        if (lastAjaxAbort) lastAjaxAbort()

        let {data, abort} = await ajax({
            url: '/esb/portfolio/cusip/issuedata',
            method: 'GET',
            params: { cusip }
        })

        lastAjaxAbort = abort
        let info = ((await data) || {}).IssueData
        lastAjaxAbort = null

        if (!info) return null

        return {
            holdCusip: info.cusip,
            holdIssue: info.issueDisplay,
            holdInvType: info.type,
            moodyRating: info.moodyRating,
            spRating: info.spRating,
            holdCoupon: info.coupon,
            firstCouponDate: info.firstCoupon,
            holdCorpSector: fmtSectorCode(info.sectorCode),
            nextCouponDate: info.nextCoupon,
            deliveryType:info.delivery==='C' ? 'Cash' : 'Book Entry',
            datedDate: info.dated,
            holdUseOfProceeds: fmtUseOfProceeds(info.useOfProceeds),
            research: info.research
        }
    } catch(e) {
        return undefined
    }
}

const USE_OF_PROCEEDS = {
    'Z': 'Agriculture',
    'E': 'Education',
    'G': 'Government',
    'H': 'Healthcare',
    'A': 'Housing',
    'I': 'Industrial',
    'R': 'Recreation',
    'T': 'Transporation',
    'U': 'Utilities'
}
const fmtUseOfProceeds = (v) => {
    let c = (''+v)[0]
    return USE_OF_PROCEEDS[c] || ''
}

const SECTOR_CODE = {
    BM: 'Basic Materials',
    CG: 'Consumer Goods',
    CS: 'Consumer Services',
    FI: 'Financials',
    HC: 'Healthcare',
    IN: 'Industrials',
    OG: 'Oil & Gas',
    OT: 'Other',
    TY: 'Technology',
    TE: 'Telecommunications',
    TR: 'Transportation',
    UT: 'Utilities'
}

const fmtSectorCode = (v) => {
    return SECTOR_CODE[v] || ''
}


// WEBPACK FOOTER //
// ./src/twd/format/issuer/get-issue-data.js